<template>
  <Layout>
    <div class="row app-user-avatar">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-body-form">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>原密码</label>
                    <input
                      v-model="item.oldPassword"
                      type="password"
                      class="form-control"
                      placeholder="请输入原密码"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>新密码</label>
                    <input
                      v-model="item.newPassword"
                      type="password"
                      class="form-control"
                      placeholder="请输入新密码"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>确认新密码</label>
                    <input
                      v-model="item.confirmPassowrd"
                      type="password"
                      class="form-control"
                      placeholder="请确认新密码"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row submit-bar">
              <div class="col-md-12">
                <div class="bar-handle"   v-if="power['编辑']">
                  <button
                    @click="submitPreserve()"
                    class="btn-sm btn btn-primary"
                    type="button"
                  >
                    提交
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import user from "../../../server/api/user";
import imageUpload from "../../../components/imageUpload";

export default {
  components: {
    Layout,
    imageUpload,
  },
  data() {
    return {
      item: {},
      index_id: true,
      power: "",
    };
  },

  mounted() {
     this.power = this.utils.currentPower("创作平台-用户中心");
    // // 获取详情
    // if (this.$route.query.id) {
    //   this.index_id = this.$route.query.id;
    //   this.fetch()
    // }
  },

  methods: {
    fetch() {
      var params = {
        id: this.index_id,
      };
      content.detail(params).then((resp) => {
        if (resp.code == 0) {
        }
      });
    },

    submitPreserve() {
      let params = JSON.parse(JSON.stringify(this.item)); //copy对象
      if (!params.oldPassword) {
        Vue.swal("请输入原密码");
        return;
      }
      if (!params.newPassword) {
        Vue.swal("请输入新密码");
        return;
      }
      if (params.confirmPassowrd) {
        if (params.newPassword == params.confirmPassowrd) {
          delete params.confirmPassowrd;
        } else {
          Vue.swal("两次输入密码不一致");
          return;
        }
      } else {
        Vue.swal("请确认新密码");
        return;
      }
      if (this.index_id) {
        user.passwordModify(params).then((resp) => {
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: "保存成功！",
              showConfirmButton: false,
              timer: 1000,
            });
            // this.goBack()
          } else {
            Vue.swal(resp.msg);
          }
        });
      } else {
        content.createVideo(params).then((resp) => {
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: "保存成功！",
              showConfirmButton: false,
              timer: 1000,
            });
            this.goBack();
          } else {
            Vue.swal(resp.msg);
          }
        });
      }
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.app-user-avatar .submit-bar {
  text-align: center;
}

.app-user-avatar .submit-bar .bar-handle {
  display: inline-block;
  float: inherit;
}

.app-user-avatar .submit-bar .bar-handle button {
  margin-left: 0;
}

.app-user-avatar .app-image-upload {
  display: inline-block;
}

.app-user-avatar .app-image-upload .avatar-uploader .el-upload {
  border-radius: 50%;
}
</style>
